import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { OrganizationsService } from 'src/app/services/organizations.service';
import { IOrganization } from 'src/app/models/organizations/organization';
import { OrganizationResult } from 'src/app/models/organizations/organization-result';

@Component({
  selector: 'app-organization-info',
  templateUrl: './organization-info.component.html',
  styleUrls: ['./organization-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class OrganizationInfoComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  organization: IOrganization | null = null;
  loaded: boolean = false;

  ngOnInit(): void {
    this.loadOrganization();
  }

  loadOrganization(): void {
    const id: string = this.route.snapshot.paramMap.get('id')!;
    this.organizationsService
      .getOrganization(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: OrganizationResult) => {
        this.organization = result.organization;
        this.loaded = true;
      });
  }

  onChildSaved(refreshed: IOrganization): void {
    this.organization = refreshed;
  }

  goBack(): void {
    this.router.navigate(['organizations']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private organizationsService: OrganizationsService,
  ) {}
}
